import { jsx as _jsx } from "react/jsx-runtime";
import { ListBoxItem, composeRenderProps } from 'react-aria-components';
import { genericForwardRef } from '../../utils/genericForwardRef.js';
import { twMerge } from '../../utils/twMerge.js';
export const OptionListItem = /* #__PURE__ */ genericForwardRef(function OptionListItem(props, forwardedRef) {
    return (_jsx(ListBoxItem, { ...props, 
        // @ts-expect-error -- bug in react-aria-components 1.3.0 types?
        ref: forwardedRef, className: composeRenderProps(props.className, (className) => twMerge('ppl-OptionListItem cursor-default px-3 py-1 text-body-md text-default outline-none transition-[box-shadow,border-color,outline]', 
        // hover states
        'hover:bg-default-subdued-hover', 
        // selected states
        'selected:bg-accent-subdued', 
        // selected hover states
        'selected:hover:bg-accent-subdued-hover', 
        // selected focus visible states
        'selected:focus-visible:bg-accent-subdued', 
        // focus visible states
        'focus-visible:ring focus-visible:ring-inset focus-visible:ring-accent/[.38]', 
        // disabled states
        'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-40', 
        // pass through styles
        className)) }));
});
//# sourceMappingURL=OptionListItem.js.map